import * as React from "react";
import {Fragment} from "react";
import BillPaidNotification from "../../../model/notification/invoice/BillPaidNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: BillPaidNotification;
}

/**
 * Bill paid notification toast body.
 */
const NotificationBillPaidBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Bill {props.notification.data.jobRefNumber}</div>
			<div className={"toast-body"}>
				Bill has been paid
			</div>
		</Fragment>
	);
};

export default NotificationBillPaidBody;
